import {Injectable} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {catchError} from 'rxjs/operators';

import {Logger} from '../logger.service';
import {environment} from 'src/environments/environment';

const log = new Logger('ErrorHandlerInterceptor');

/**
 * Adds a default error handler to all requests.
 */
@Injectable({
    providedIn: 'root',
})
export class ErrorHandlerInterceptor implements HttpInterceptor {
    intercept(
        request: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next
            .handle(request)
            .pipe(catchError((error) => this.errorHandler(error)));
    }

    // Customize the default error handler here if needed
    private errorHandler(response: any): Observable<HttpEvent<any>> {
        if (environment.production) {
            // Do something with the error

            const errorResponse: HttpErrorResponse = response as HttpErrorResponse;
            if (!errorResponse) {
                return;
            }
            // log.error('There is a request error', errorResponse);
            const error = {
                message: errorResponse.error.message
                    ? errorResponse.error.message
                    : errorResponse.error.error_description
                        ? errorResponse.error.error_description
                        : errorResponse.message,
                path: errorResponse.error.path
                    ? errorResponse.error.path
                    : errorResponse.url,
                error: errorResponse.error.error,
                httpStatus: errorResponse.status,
                httpStatusText: errorResponse.statusText,
                targetAPIError: errorResponse.error.targetAPIError,
                detailTargetAPIErrorMessage: errorResponse.error.detailTargetAPIErrorMessage
            };

            if (error.message.indexOf('Access token expired', 0) > -1) {
                error.message = 'Login expired... Login again !';
            }
            log.error('APIError : ', error);
            return throwError(error);
        } else if (!environment.production) {
            // Do something with the error

            const errorResponse: HttpErrorResponse = response as HttpErrorResponse;
            if (!errorResponse) {
                return;
            }
            const error = {
                message: errorResponse?.error?.message
                    ? errorResponse?.error?.message
                    : errorResponse?.error?.error_description
                        ? errorResponse?.error?.error_description
                        : errorResponse?.message,
                path: errorResponse?.error?.path
                    ? errorResponse?.error?.path
                    : errorResponse?.url,
                error: errorResponse?.error?.error,
                httpStatus: errorResponse?.status,
                httpStatusText: errorResponse?.statusText,
                targetAPIError: errorResponse?.error?.targetAPIError,
                detailTargetAPIErrorMessage: errorResponse?.error?.detailTargetAPIErrorMessage,
            };

            if (error.message.indexOf('Access token expired', 0) > -1) {
                error.message = 'Login expired... Login again !';
            }
            log.error('APIError : ', error);
            return throwError(error);
        }
    }
}

